import { Component, OnInit, OnDestroy, AfterContentInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { CmsserviceService } from '../../../common-cms-service/cmsservice.service';
import { CommonAccountVerifyService } from '../../../common-myaccount-service/common-account-verify.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

declare var jquery: any;
declare var $: any;

/** One clickable item inside a mega-menu column */
interface MegaLink {
  icon: string;
  title: string;
  desc?: string;
  badge?: string;
  badgeHot?: boolean;
  route?: any[];
  href?: string;
}

/** One column inside a mega-menu. `visible` is the on/off switch —
 *  toggle it from this file (or wire it to a backend flag) to show/hide
 *  a whole section without touching the template. */
interface MegaColumn {
  id: string;
  label: string;
  visible: boolean;
  links: MegaLink[];
}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy, AfterContentInit {
  title = '';
  pagetitle: string;
  categoryListing: any;
  pageslug: string;
  siteSetting: any;
  categories = [];
  catDetail = [];
  slug: string;
  ngUnsubscribe = new Subject<void>();
  isLoggedInUser: boolean;
  testPopup = true;
  poptitle: string;
  frontBaseURL = environment.frontBaseURL;
  username: any;
  lastname: any;
  cookieValue: string;
  dropdownOpen = false;

  filtered11PlusCategories: any[] = [];
  filteredGCSECategories: any[] = [];

  // ---------- scroll state ----------
  headerScrolled = false;

  // ---------- mobile off-canvas panel ----------
  mobileNavOpen = false;
  activeMobileAccordion: string = null;

  // ---------- desktop mega-menu: force-close on click ----------
  // Hover-driven dropdowns stay open as long as the mouse is over them,
  // even after a link is clicked. Clicking sets `megaSuppressed` true for
  // a short window (enough time for routing to kick in) which forces every
  // `.sh-mega` closed via CSS regardless of :hover state.
  megaSuppressed = false;
  private megaSuppressTimer: any;

  // =====================================================================
  // MEGA-MENU CONFIG
  // Each menu is a plain array of columns. Flip `visible` to show/hide a
  // whole column (e.g. hide "Special Courses" during term time) without
  // touching header.component.html. This is the FULL set of links from
  // the original nav — nothing left out on purpose.
  // =====================================================================

  elevenPlusColumns: MegaColumn[] = [
    {
      id: 'overview', label: 'Overview', visible: true,
      links: [
        { icon: 'ti-help-circle', title: 'What is 11+?', desc: 'The basics, explained simply', route: ['/w11plus'] },
        { icon: 'ti-book-open', title: 'FSCE 11+ Overview', route: ['/fsce-11-plus-exam-overview'] },
        { icon: 'ti-checklist', title: '11+ Consortiums', desc: 'Regional test groups explained', route: ['/consortium'] },
        { icon: 'ti-calendar-stats', title: '11+ Key Dates', desc: 'Exam & registration timeline', route: ['/key-dates'] },
        { icon: 'ti-building-bank', title: 'Grammar Schools', desc: 'Find schools by region', route: ['/grammar-schools'] },
        { icon: 'ti-building', title: 'Top Private Schools', route: ['/private-schools'] }
      ]
    },
    {
      id: 'mock', label: 'Mock Test', visible: true,
      links: [
        { icon: 'ti-clipboard-text', title: '11+ Mock Test', desc: 'Timed, exam-style papers', route: ['/11plus-mock-test'] },
        { icon: 'ti-file-text', title: '11+ Topic Test', desc: 'Practise by subject area', route: ['/11plus-topic-test'] },
        { icon: 'ti-clipboard-check', title: 'Year 4 Topic Test', route: ['/year-4-mock-test'] },
        { icon: 'ti-rocket', title: '11+ Sprint', route: ['/11plus-sprint'] },
        { icon: 'ti-database', title: '11+ Exam Question Bank', route: ['/question-bank'] },
        { icon: 'ti-current-location', title: 'Mock Test Locations', desc: 'Find a centre near you', route: ['/locations'] },
        { icon: 'ti-gift', title: '11+ Offers', route: ['/offer-free-resources'] },
        { icon: 'ti-bolt', title: '11+ Chelmsford Mock', route: ['/11plus-mocks-chelmsford'] },
        { icon: 'ti-users', title: 'Free CSSE Predictor', desc: 'Weekly small-group tuition', badge: 'Popular', route: ['/free-csse-predictor'] },
      ]
    },
    {
      id: 'tuition', label: 'Tuition', visible: true,
      links: [
        { icon: 'ti-users', title: 'Join 11+ Classes', desc: 'Weekly small-group tuition', badge: 'Popular', route: ['/11Plus-classes'] },
        { icon: 'ti-forms', title: '11+ Admissions', route: ['/11plus-admission'] },
        { icon: 'ti-currency-pound', title: '11+ Course Pricing', route: ['/11plus-course-pricing'] },
        { icon: 'ti-video', title: '11+ Webinar', desc: 'Free info session', route: ['/webinar'] },
        { icon: 'ti-calendar', title: '11+ Upcoming Sessions', href: 'https://www.sehyog.co.uk/11plus-help-club/category' },
        { icon: 'ti-users-group', title: '11+ HelpClub (Free)', route: ['/11plus-HelpClub'] },
        { icon: 'ti-gift', title: '11+ Free Resources', desc: 'Downloads & help club', route: ['/free-resources'] },
        { icon: 'ti-download', title: '11+ Digital Download', route: ['/digital-download'] },
        { icon: 'ti-clipboard-check', title: '11+ Free Assessment', route: ['/free-assessment'] },
        { icon: 'ti-clipboard-check', title: '11+ Pre-Admission Assessment', route: ['/11plus-assessment'] }
      ]
    },
    // {
    //   id: 'summer', label: 'Summer Course', visible: true,
    //   links: [
    //     { icon: 'ti-bolt', title: '11+ Intensive Course (All Subjects)', desc: 'All-subjects fast track', route: ['/11plus-summer-intensive'] },
    //     { icon: 'ti-sun', title: '11+ Summer Bootcamp Courses', desc: 'Intensive revision course', badge: 'Offer', badgeHot: true, route: ['/11plus-summer-bootcamp'] },
    //     // { icon: 'ti-calculator', title: '11+ Intensive Course — Maths', href: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/b618fddc1bce2f1a22d8584688f52fea' },
    //     // { icon: 'ti-cube', title: '11+ Intensive Course — NVR & Spatial Reasoning', href: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/c4f75dea69f3aa757f1c8fce778e5100' },
    //     // { icon: 'ti-book', title: '11+ Revision — English, Reading Comprehension & Creative Writing', href: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/4c53fff4c24e8b1043f456b92ea0b09e' },
    //     // { icon: 'ti-message-2', title: '11+ Revision — Verbal Reasoning', href: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/3e5cd97221c44397a12a18ae2433ddcf' },
    //     // { icon: 'ti-book-2', title: '11+ Revision — Reading Comprehension', href: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/e8457c5d910d99ff24ab8036930c6b84' }
    //   ]
    // },
    {
      id: 'special', label: 'Special Courses', visible: true,
      links: [
        { icon: 'ti-bolt', title: '11+ Intensive Course', route: ['/rapid-course'] },
        { icon: 'ti-pencil', title: 'Creative Writing Course', desc: 'Story & composition skills', route: ['/creative-writing'] },
        { icon: 'ti-abc', title: 'SPaG Rapid Course', desc: 'Grammar & punctuation', route: ['/spag-course'] },
        { icon: 'ti-building-bridge-2', title: '11+ Bridge Course (Y4–Y5)', route: ['/bridge-courses'] }
      ]
    }
  ];

  gcseColumns: MegaColumn[] = [
    {
      id: 'overview', label: 'Overview', visible: true,
      links: [
        { icon: 'ti-forms', title: 'GCSE Admissions', route: ['/gcse-admission'] },
        { icon: 'ti-calendar', title: 'Upcoming Sessions', href: 'https://www.sehyog.co.uk/11plus-help-club/category' }
      ]
    },
    {
      id: 'mock', label: 'Mock Test', visible: true,
      links: [
        { icon: 'ti-clipboard-text', title: 'GCSE Full Mock Test', desc: 'Complete exam simulation', route: ['/gcse-mock-test'] },
        { icon: 'ti-clipboard-check', title: 'GCSE Mini Mock Test', route: ['/gcse-mini-mocks'] },
        { icon: 'ti-clipboard-check', title: 'Year 10 GCSE Mock Test', desc: 'Early-start practice papers', route: ['/year-10-mock-test'] },
        { icon: 'ti-school', title: 'KS-3 Mock Tests', desc: 'Build exam readiness early', route: ['/ks3-mock-test'] },
        { icon: 'ti-current-location', title: 'Mock Test Locations', route: ['/location'] },
        { icon: 'ti-gift', title: 'GCSE Offers', route: ['/offer-free-resources'] }
      ]
    },
    {
      id: 'tuition', label: 'Tuition', visible: true,
      links: [
        { icon: 'ti-users', title: 'Join GCSE Classes', desc: 'Subject-specific tuition', route: ['/gcse-classes'] },
        { icon: 'ti-video', title: 'Webinar', desc: 'Free info session', route: ['/webinar'] },
        { icon: 'ti-users-group', title: 'GCSE Help Club (Year 9)', desc: 'Year 9 free sessions', route: ['/gcse-help-club'] }
      ]
    },
    {
      id: 'summer', label: 'Summer Course', visible: true,
      links: [
        { icon: 'ti-sun', title: 'GCSE Summer Bootcamp', desc: 'Fast-track revision', badge: 'Offer', badgeHot: true, route: ['/gcse-summer-bootcamp'] }
      ]
    },
    {
      id: 'special', label: 'Special Courses', visible: true,
      links: [
        { icon: 'ti-code', title: 'Python Adventures', desc: 'Intro to coding', route: ['/python-course'] }
      ]
    }
  ];

  // Combined A-Level + Tuition mega-menu (single menu, single CTA panel)
  tuitionColumns: MegaColumn[] = [
    {
      id: 'levels', label: 'All Levels', visible: true,
      links: [
        { icon: 'ti-flower', title: 'Early Year Tuition', href: 'https://go.sehyog.co.uk/FreeDemoForm' },
        { icon: 'ti-hash', title: '11+ Tuition', route: ['/11Plus-classes'] },
        { icon: 'ti-clipboard-list', title: '12+ Tuition', href: 'https://go.sehyog.co.uk/FreeDemoForm' },
        { icon: 'ti-school', title: '13+ Tuition', href: 'https://go.sehyog.co.uk/FreeDemoForm' },
        { icon: 'ti-school', title: 'KS3 Tuition', route: ['/ks3-tution'] },
        { icon: 'ti-certificate', title: 'GCSE Tuition', route: ['/gcse-classes'] },
        { icon: 'ti-edit', title: 'SATs Tuition', href: 'https://go.sehyog.co.uk/FreeDemoForm' }
      ]
    },
    {
      id: 'alevel', label: 'A-Level', visible: true,
      links: [
        { icon: 'ti-book-2', title: 'AS-Level Tuition', desc: 'Year 12 subject support', href: 'https://go.sehyog.co.uk/FreeDemoForm' },
        { icon: 'ti-book', title: 'A-Level Tuition', desc: 'Year 13 exam preparation', href: 'https://go.sehyog.co.uk/FreeDemoForm' },
        { icon: 'ti-video', title: 'Webinar', route: ['/webinar'] },
        { icon: 'ti-calendar', title: 'Upcoming Sessions', href: 'https://www.sehyog.co.uk/11plus-help-club/category' },
      ]
    }
  ];

  uniProgramLinks: MegaLink[] = [
    { icon: 'ti-ai', title: 'AI & Data Tech Courses', route: ['/genAI-dataScience-program'] },
    { icon: 'ti-chart-dots', title: 'Data Science', route: ['/data-science'] },
    { icon: 'ti-message-2', title: 'Prompt Engineering' },
    { icon: 'ti-briefcase', title: 'Interview & Career Skills' },
    { icon: 'ti-info-circle', title: 'How It Works / Eligibility' }
  ];

  aboutUsColumns: MegaColumn[] = [
    {
      id: 'about', label: 'About', visible: true,
      links: [
        { icon: 'ti-package', title: 'Product & Services', route: ['/product-services'] },
        { icon: 'ti-heart-handshake', title: 'Vision & Mission', route: ['/sehyog/vision-mission'] },
        { icon: 'ti-users', title: 'Team', route: ['/sehyog/team'] },
        { icon: 'ti-timeline', title: 'Inception Story', route: ['/sehyog/inception-story'] }
      ]
    },
    {
      id: 'inspired', label: 'Get Inspired', visible: true,
      links: [
        { icon: 'ti-trophy', title: 'Success Stories', route: ['/11plus-help-club/get-inspired/success-stories'] },
        { icon: 'ti-star', title: 'Testimonials', route: ['/11plus-help-club/get-inspired/testimonial'] },
        { icon: 'ti-photo', title: 'Photo Gallery', route: ['/sehyog/photo-gallery'] },
        { icon: 'ti-video', title: 'Video Gallery', route: ['/sehyog/video-gallery'] }
      ]
    },
    {
      id: 'support', label: 'Support', visible: true,
      links: [
        { icon: 'ti-help-circle', title: 'General FAQ', route: ['/faq/general-faq'] },
        { icon: 'ti-message-2', title: 'Parent/Teacher FAQ', route: ['/faq/parent-faq'] },
        { icon: 'ti-headset', title: 'Support Form', route: ['/support'] }
      ]
    },
    {
      id: 'international', label: 'International', visible: true,
      links: [
        { icon: 'ti-world', title: 'Tuition in UAE', route: ['/UAE'] },
        { icon: 'ti-world', title: 'Tuition in India', route: ['/india'] }
      ]
    }
  ];

  constructor(
    private cmsService: CmsserviceService,
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private logoutService: CommonAccountVerifyService,
    private cookiesService: CookieService

  ) {
    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        window.scroll(0, 0);
        const slugArr = val.url.split('/');
        const allow = ['contact-us', 'donation', 'support', 'request-for-franchise', 'freedemo'];
        if (allow.includes(slugArr[slugArr.length - 1])) {
          this.testPopup = false;
        } else {
          this.testPopup = true;
        }
        this.closeMobileNav();
      }
    });
  }
  ngOnInit() {
    this.loadHeaderAssets();
    window.addEventListener('scroll', this.scroll, true);
    this.CategoryList();
    this.userIdentifyMyaccount();
    this.getTestCategoryList();
    this.cmsService.commonSiteSetting();
    this.cmsService.commonSiteSettingSingleton().subscribe(res => {
      this.siteSetting = res;
      $('body').find('.header-basket-count').html(res.user_basket_count);
    });

  }

  /** comment
   * loads Space Grotesk / Nunito + Tabler Icons webfont once per page,
   * same pattern used across other Sehyog components (link tag + guard)
   */
  loadHeaderAssets(): void {
    if (!document.getElementById('sh-fonts-link')) {
      const fontLink = document.createElement('link');
      fontLink.id = 'sh-fonts-link';
      fontLink.rel = 'stylesheet';
      fontLink.href = 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Nunito:wght@400;500;600;700&display=swap';
      document.head.appendChild(fontLink);
    }
    if (!document.getElementById('sh-tabler-icons-link')) {
      const iconLink = document.createElement('link');
      iconLink.id = 'sh-tabler-icons-link';
      iconLink.rel = 'stylesheet';
      iconLink.href = 'https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css';
      iconLink.onerror = function () {
        // fallback CDN if jsdelivr is unreachable on this network
        const fallback = document.createElement('link');
        fallback.id = 'sh-tabler-icons-link-fallback';
        fallback.rel = 'stylesheet';
        fallback.href = 'https://cdnjs.cloudflare.com/ajax/libs/tabler-icons/3.46.0/tabler-icons.min.css';
        document.head.appendChild(fallback);
      };
      document.head.appendChild(iconLink);
    }
  }

  /** comment
   * to get categories
   */
  CategoryList() {
    this.cmsService.getFaqCategoryList()
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
        this.categories = res.data;

      });
  }
  scroll = (): void => {
    this.headerScrolled = window.scrollY > 40;
    if (window.scrollY > 200) {
      $('.header-fixed').addClass('darkHeader');
    } else {
      $('.header-fixed').removeClass('darkHeader');
    }
  };
  userLogouts() {
    this.logoutService.logout();
    this.isLoggedInUser = false;
    this.ngOnInit();
    this.router.navigate(['/']);
  }

  /** comment
   * get test category
   */
  getTestCategoryList() {
    this.cmsService.getTestCategories()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {

        // All categories
        this.categoryListing = res.data || [];

        // Only 11+ / 11plus categories
        this.filtered11PlusCategories = this.categoryListing.filter(category =>
          /11\+|11plus/i.test(category.category_name)
        );

        // Only GCSE categories
        this.filteredGCSECategories = this.categoryListing.filter(category =>
          /GCSE/i.test(category.category_name)
        );

      });
  }

  /** comment
   * get user login record
   */
  userIdentifyMyaccount() {
    this.isLoggedInUser = false;
    const username = localStorage.getItem('userfname');
    if (username) {
      if (username.length > 12) {
        this.username = username.substring(0, 12) + '.';
      } else {
        this.username = username;
      }
    }
    this.cookieValue = this.cookiesService.get('userLogin');
    this.lastname = localStorage.getItem('userlname');
    const isLogginTrue = localStorage.getItem('isUserLoggedIn');
    const usertoken = localStorage.getItem('usertoken');
    if ((this.username) && (isLogginTrue) && (usertoken) && (this.cookieValue)) {
      this.isLoggedInUser = true;
    } else {
      this.isLoggedInUser = false;
    }

    setTimeout(() => {
      $('.dropdown-toggle').dropdown();
    }, 0);
  }

  /** comment
   * allow to type only number
   */
  checkMobileNumber() {
    $('.uphone').keydown(function (e) {
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        (e.keyCode >= 35 && e.keyCode <= 40)) {
        return;
      }
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });
  }

  ngAfterContentInit(): void {

    $(document).ready(function () {
      $('body').prepend('<div class="load1"></div>');
      $('body').prepend('<div class="load2"></div>');
    });

  }

  openPhoneNumber() {
    window.open('tel:+44(0)2039808244');
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  // =====================================================================
  // MEGA-MENU helpers
  // =====================================================================

  /** Only the columns currently switched on, for a given menu array. */
  visibleColumns(columns: MegaColumn[]): MegaColumn[] {
    return columns.filter(function (col) { return col.visible; });
  }

  /** 4+ visible columns need a tighter layout (hide descriptions, smaller icons). */
  isCompact(columns: MegaColumn[]): boolean {
    return this.visibleColumns(columns).length >= 4;
  }

  // =====================================================================
  // MOBILE OFF-CANVAS PANEL
  // =====================================================================

  openMobileNav(): void {
    this.mobileNavOpen = true;
    $('body').addClass('sh-noscroll');
  }

  closeMobileNav(): void {
    this.mobileNavOpen = false;
    this.activeMobileAccordion = null;
    $('body').removeClass('sh-noscroll');
  }

  toggleMobileAccordion(id: string): void {
    this.activeMobileAccordion = (this.activeMobileAccordion === id) ? null : id;
  }

  // =====================================================================
  // DESKTOP MEGA-MENU force-close
  // =====================================================================

  /** Bound to (click) on every link inside a mega-menu (including its CTA button). */
  closeMegaMenu(): void {
    this.megaSuppressed = true;
    if (this.megaSuppressTimer) {
      clearTimeout(this.megaSuppressTimer);
    }
    this.megaSuppressTimer = setTimeout(() => {
      this.megaSuppressed = false;
    }, 350);
  }

  /** Safety net: bound to (mouseleave) on the nav bar, so suppression never lingers. */
  resetMegaSuppression(): void {
    this.megaSuppressed = false;
    if (this.megaSuppressTimer) {
      clearTimeout(this.megaSuppressTimer);
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.scroll, true);
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


}